import avatar from '@/assets/images/avatar.png';
import back_image from '@/assets/images/back_image.svg';
import bg from '@/assets/images/bg.jpg';
import _default from '@/assets/images/default.png';
import qcc from '@/assets/images/qcc.png';
import shipin from '@/assets/images/shipin.svg';
import header from '@/assets/login/header.png';




export default {
	avatar,
	back_image,
	bg,
	_default,
	qcc,
	shipin,
	header
}